import React from "react";
import Tooltip from "../Tooltip/Tooltip";
import {
  ticketStatusEnum,
  type TicketStatusOption,
} from "../../../utils/TicketStatusUtils";
import "./TicketStatus.scss";

export interface TicketStatusProps {
  status?: string | null;
  withLabel?: boolean;
  "data-testid"?: string | null;
}

const TicketStatus: React.FC<TicketStatusProps> = ({
  status,
  withLabel = true,
  "data-testid": dataTestId,
}) => {
  const statusOption: TicketStatusOption | undefined = status
    ? ticketStatusEnum[status]
    : undefined;

  if (!statusOption) {
    return null;
  }

  const label = statusOption.text;

  return (
    <Tooltip content={label}>
      <div
        className={"ticket-status"}
        data-testid={dataTestId ? `${dataTestId}-ticket-status` : undefined}
      >
        <div
          className={`ticket-status-dot ${statusOption.value.toLowerCase()}`}
        />
        {withLabel && <span className={"ticket-status-label"}>{label}</span>}
      </div>
    </Tooltip>
  );
};

export default TicketStatus;
